module.exports = __webpack_public_path__ + "static/img/project_person1.c52be12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project_person1.png
// module id = GiW8
// module chunks = 1